export const ISO4217List = [
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BGN",
  "BHD",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BOV",
  "BRL",
  "BSD",
  "BTN",
  "BWP",
  "BYN",
  "BZD",
  "CAD",
  "CDF",
  "CHE",
  "CHF",
  "CHW",
  "CLF",
  "CLP",
  "CNY",
  "COP",
  "COU",
  "CRC",
  "CUC",
  "CUP",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ERN",
  "ETB",
  "EUR",
  "FJD",
  "FKP",
  "GBP",
  "GEL",
  "GHS",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HRK",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "INR",
  "IQD",
  "IRR",
  "ISK",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KMF",
  "KPW",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "LYD",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRO",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MXV",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SDG",
  "SEK",
  "SGD",
  "SHP",
  "SLL",
  "SOS",
  "SRD",
  "SSP",
  "STD",
  "SVC",
  "SYP",
  "SZL",
  "THB",
  "TJS",
  "TMT",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TWD",
  "TZS",
  "UAH",
  "UGX",
  "USD",
  "USN",
  "UYI",
  "UYU",
  "UZS",
  "VEF",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XAG",
  "XAU",
  "XBA",
  "XBB",
  "XBC",
  "XBD",
  "XCD",
  "XDR",
  "XOF",
  "XPD",
  "XPF",
  "XPT",
  "XSU",
  "XTS",
  "XUA",
  "XXX",
  "YER",
  "ZAR",
  "ZMW",
  "ZWL",
] as const;

export type ISO4217CurrencyCode = (typeof ISO4217List)[number];

export const SupportedCurrencies: ISO4217CurrencyCode[] = [
  "EUR",
  "GBP",
  "NGN",
  "USD",
];

interface CurrencyPair {
  sourceCurrency: ISO4217CurrencyCode;
  targetCurrency: ISO4217CurrencyCode;
}

// function to turn a list of countries into a list of currencyPair
function mapISO4217CountryCodeToCurrencyPair(
  currencies: ISO4217CurrencyCode[]
): CurrencyPair[] {
  const currenciesPairs: CurrencyPair[] = [];

  for (let i = 0; i < currencies.length; i++) {
    for (let j = 0; j < SupportedCurrencies.length; j++) {
      const sourceCurrency = currencies[i];
      const targetCurrency = currencies[j];
      if (sourceCurrency !== targetCurrency) {
        currenciesPairs.push({
          sourceCurrency,
          targetCurrency,
        });
      }
    }
  }

  return currenciesPairs;
}

export function formatCurrencyPair(currencyPair: CurrencyPair): string {
  return `${currencyPair.sourceCurrency}/${currencyPair.targetCurrency}`;
}

export const iSO4217CountryCodeDrownDownData =
  mapISO4217CountryCodeToCurrencyPair(SupportedCurrencies).map(
    (currencyPair) => ({
      label: formatCurrencyPair(currencyPair),
      value: `${currencyPair.sourceCurrency}/${currencyPair.targetCurrency}`,
    })
  );
